import {Td, Tr} from '@chakra-ui/react'

export const RowsMissedRow = (props) => {
	const {name, category} = props
	return (
		<>
			<Tr>
				<Td>
					{name}
				</Td>
				<Td>
					{category}
				</Td>
			</Tr>
		</>
	)
}